<template>
  <div>
    <div class="addTemporaryModal">
      <Form ref="addTemporaryModalForm" :label-width="80" :model="TemporaryFrom"
            :rules="addTemporaryModalRules">
        <FormItem label="姓名" prop="name">
          <Input v-model="TemporaryFrom.name" placeholder="请输入姓名"></Input>
        </FormItem>
        <FormItem label="联系方式" prop="phone">
          <Input v-model="TemporaryFrom.phone" placeholder="请输入联系方式"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="TemporaryFrom.remark" placeholder="请输入备注"></Input>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
export default {
  name: "addTemporaryModal",
  props: {
    addTemporaryModalIsShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    addTemporaryModalIsShow: {
      handler: function (val) {
        if (val) {
          this.TemporaryFrom = {
            name: '',
            phone: '',
            remark: ''
          }
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      TemporaryFrom: {
        name: '',
        phone: '',
        remark: ''
      },
      addTemporaryModalRules: {}
    }
  }
}
</script>

<style scoped>

</style>
